module.exports = "data:image/webp;base64,UklGRuQAAABXRUJQVlA4INgAAADQBQCdASoZABkAPpFAmEmlo6IhKAqosBIJYwCy+oAIlwKXqBE+QcHreGnpgMY3NzPojoSS3lbgAP7q7v+/PpHYco6sM9ZoMho7swmuQktiwH9eJzc5TBvrg9dbW44vaKP6v0KfaiqD+tQu27eWQ5Ru4Y+XezUQnY0emHiyQH60Raaz9ODuctvaOzf+1nRHoQVdSlwdy4m5O8SH8buTTHhyM4KWQTFnD2fGTOYGnPx49kku/SDJEVO/Yz6oe2u9pgALUQ++aig7Fb1ywJrZb6sLebXED6gAAAA="


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/sundust.webp
// module id = tw9o
// module chunks = 14